import React, { Component } from "react";
import logo from "./logo.svg";
import "./App.css";
import Pokemon from "./components/Pokemon";
import Profile from "./components/Profile";




class App extends Component {
  constructor() {
    super();
    this.state = {
      allPokemon: null,
      infoLoaded: false,
      profileLoaded: false,
      profile: null,
    };
    this.displayInfo = this.displayInfo.bind(this);
  }

  displayInfo(url) {
    fetch(`${url}`)
      .then(response => response.json())
      .then(response => {
        console.log(response);
        this.setState({
          profile: response,
          profileLoaded: true,
        });
      })
      .catch(err => console.log(err));
  }



  componentDidMount() {
    fetch("https://pokeapi.co/api/v2/pokemon/?limit=151")
      .then(response => response.json())//we want to covert the data to json
      .then(response => {
        console.log(response.results);
        this.setState({
          allPokemon: response.results,
          infoLoaded: true,
        });
      })
      .catch(err => console.log(err));
  }

  render() {
    return (


      <div className='background'>
       {this.state.infoLoaded ? (
        <div className="pokemon_app" >

          <div className='allPokemon' >
            <Pokemon allPokemon={this.state.allPokemon}
                    displayInfo={this.displayInfo}
                    />
          </div>

          <div className='profile'>
            <Profile profile={this.state.profile}
                     profileLoaded={this.state.profileLoaded}
                    />
          </div>

        </div>

        ):(

        <div>Loading</div>

        )}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js